import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import timezone from 'dayjs/plugin/timezone';
import updateLocale from 'dayjs/plugin/updateLocale';

import 'dayjs/locale/en';
import 'dayjs/locale/it';
import 'dayjs/locale/es';

dayjs.extend(localizedFormat);
dayjs.extend(timezone);
dayjs.extend(updateLocale);

dayjs.locale('en');

const config = {
  formats: {
    LT: 'HH:mm',
    L: 'DD/MM/YY',
  },
};

dayjs.updateLocale('en', config);
dayjs.updateLocale('it', config);
dayjs.updateLocale('es', config);

export default dayjs;
